export let backgroundWaveMixinBlock = {
	initBackgroundWave: (self) => {
		self.$element = self.$element || $(self.element);

		if(self.$element.data('backgroundWave')) {
			let $inner = self.$element.find('[background-wave-inner]');
			let $innerContent = $inner.find('[background-wave-inner-content]');

			$inner.css({
				position: 'relative'
			});

			// Requires the inner divs to have a z-index
			$innerContent.css({
				zIndex: 60,
				position: 'relative'
			});

			let y = !_.isNil(self.$element.data('backgroundWaveY')) ? self.$element.data('backgroundWaveY') : 50;
			let topColor = self.$element.data('backgroundWaveTopColor') || 'transparent';
			let bottomColor = self.$element.data('backgroundWaveBottomColor') || 'transparent';

			let isVaildColor = (color) => {
				let $div = $('<div></div>');
				$div.css('border', '1px solid '+color);
				return ($div.css('border-color') !== '');
			};

			if(y < 0 || y > 100) {
				console.error('BackgroundWaveMixinBlock::Error', 'Please supply a valid y position between 0–100%');
				return;
			}

			if(!isVaildColor(topColor)) {
				console.error('BackgroundWaveMixinBlock::Error', 'Please supply a valid backgroundWaveTopColor value. (CSS backgroundColor)');
				return;
			}

			if(!isVaildColor(bottomColor)) {
				console.error('BackgroundWaveMixinBlock::Error', 'Please supply a valid backgroundWaveBottomColor value. (CSS backgroundColor)');
				return;
			}

			// Create wave
			let pathElements = `<path class="topBackgroundWave" d="M1440,0v66.5c0,0-279.4-81.9-716,0c-374.2,70.2-724,0-724,0V0H1440z"/><path class="bottomBackgroundWave" d="M1440,132.9V66.5c0,0-279.4-81.9-716,0c-374.2,70.2-724,0-724,0l-0.5,66.4H1440z"/>`;
			let svgObject = svgjs($inner[0]).viewbox(0, 0, 1440, 130).svg(pathElements);
			let $svgElement = $(svgObject.node);
			$svgElement.css({
				position: 'absolute',
				left: '0',
				right: '0',
				top: `${y}%`,
				transform: 'translateY(-50%)',
				zIndex: 40,
				height: 'unset'
			});

			// Apply topBackgroundColor fill for SVG
			$svgElement.find('.topBackgroundWave').css({
				fill: topColor,
				pointerEvents: 'none'
			});

			// Apply topBackgroundColor for top div
			$inner.append(`<div class="topBackground"></div>`);
			$inner.find('.topBackground').css({
				position: 'absolute',
				backgroundColor: topColor,
				top: 0,
				left: 0,
				right: 0,
				bottom: `${100 - y}%`,
				pointerEvents: 'none',
			});

			// Apply bottomBackgroundColor fill for SVG
			$svgElement.find('.bottomBackgroundWave').css({
				fill: bottomColor,
				pointerEvents: 'none'
			});

			// Apply bottomBackgroundColor for bottom div
			$inner.append(`<div class="bottomBackground"></div>`);
			$inner.find('.bottomBackground').css({
				position: 'absolute',
				backgroundColor: bottomColor,
				top: `${y}%`,
				left: 0,
				right: 0,
				bottom: 0,
				pointerEvents: 'none'
			});

			// Adjustments when the y value overflows the background
			let translateBackgrounds = () => {
				$svgElement.css({
					top: `${y}%`,
					transform: 'translateY(-50%)'
				});
				$inner.find('.topBackground').css({
					bottom: `${100 - y}%`
				});
				$inner.find('.bottomBackground').css({
					top: `${y}%`
				});

				if($inner.offset().top > $svgElement.offset().top) {
					$svgElement.css({
						top: `0`,
						transform: `translateY(0)`
					});
					$inner.find('.topBackground').css({
						bottom: `calc(100% - ${$svgElement.height() / 2}px`
					});
					$inner.find('.bottomBackground').css({
						top: `${$svgElement.height() / 2}px`
					});
				}
				else if($inner.offset().top + $inner.height() < $svgElement.offset().top + $svgElement.height()) {
					$svgElement.css({
						top: `100%`,
						transform: 'translateY(-100%)'
					});
					$inner.find('.topBackground').css({
						bottom: `${$svgElement.height() / 2}px`
					});
					$inner.find('.bottomBackground').css({
						top: `calc(100% - ${$svgElement.height() / 2}px`
					});
				}
			};

			$(window).resize(_.debounce(() => {
				translateBackgrounds();
			}, 250));

			translateBackgrounds();
		}
	}
};
